/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Heading_MisprintInputs */



/**
* | output |
* | --- |
* | "Critical misprint detected" |
*
* @param {Error_Heading_MisprintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_heading_misprint = /** @type {((inputs?: Error_Heading_MisprintInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Heading_MisprintInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kritischer Fehldruck entdeckt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur d'impression critique détectée")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("检测到严重错印")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("偵測到嚴重誤印")
	if (locale === "ko") return /** @type {LocalizedString} */ ("치명적인 인쇄 오류 발견")
	return /** @type {LocalizedString} */ ("Critical misprint detected")
});